import styled, { css } from 'styled-components'
import { keyframes } from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .card {
    padding: 16px;
    background-color: #fff;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    position: relative;

    -webkit-box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);

    h3 {
      font-weight: 600;
      font-size: 16px;
      margin-bottom: 8px;
      text-decoration: underline;
    }

    p {
      font-size: 14px;
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    strong {
      font-size: 14px;
      font-weight: 600;
    }
  }

  .pix {
    margin-top: 8px;
    font-size: 14px;
    padding: 16px;
    background-color: #f2f2f2;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 16px;

    .qr-code {
      /* background-color: #d4d4d4; */
      width: 150px;
      /* height: 150px; */
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      position: relative;
    }

    ul {
      list-style: none;
      text-align: left;

      li + li {
        margin-top: 8px;
      }
    }

    @media (max-width: 600px) {
      flex-direction: column;

      .qr-code {
        margin-bottom: 16px;
      }
    }
  }
`

export const DetailsHead = styled.div`
  display: flex;
  flex: 1;
  gap: 16px;

  @media (max-width: 800px) {
    width: 100%;
    flex-direction: column;
  }
`

export const DetailsWrapper = styled.div`
  width: 50%;

  @media (max-width: 800px) {
    width: 100%;
  }
`

export const AddressPaymentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  gap: 8px;

  @media (max-width: 800px) {
    width: 100%;
  }
`

export const AddressPaymentItem = styled.div`
  .pagamento {
    display: flex;

    img {
      width: 30px;
      margin-right: 8px;
      margin-left: -4px;
    }
  }
`

export const CopyPixCode = styled.button`
  border: none;
  cursor: pointer;
  text-decoration: underline;
  font-size: 14px;
  color: #2e2e2e;
`

const showTooltip = keyframes`
  from {
    opacity: 0;
    bottom: 0;
  } to {
    opacity: 1;
    bottom: 5px;
  }
`

type CopyTooltipProps = {
  active: boolean | null
}

export const CopyTooltip = styled.span<CopyTooltipProps>`
  ${({ active }) => css`
    display: none;
    position: absolute;
    padding: 10px 15px;
    bottom: 5px;
    left: 96px;
    min-width: 130px;

    background: #ffffff;
    border: 1px solid #afaeae;
    border-radius: 5px;
    font-size: 11px;
    font-weight: bold;
    line-height: 15px;
    text-transform: initial;
    transition: all 400ms;

    ${active &&
    css`
      display: block;
      animation: ${showTooltip} 400ms ease-in-out;
    `}
  `}
`

export const Delivery = styled.div`
  hr {
    opacity: 0.3;
    margin-bottom: 16px;
  }

  .pedido-head {
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    div {
      /* position: static;
      height: 100%; */

      position: initial;
    }
  }

  .tag-status {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
  }

  .data-entrega {
    /* margin-top: 30px; */
    text-align: right;
  }

  .nota-fiscal {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }

  .filiais {
    font-weight: 600;
    font-size: 14px;
    margin: 24px 0 -4px;

    &:first-child {
      margin-top: 0;
    }

    & strong {
      font-weight: 600;
      font-size: 14px;
      text-decoration: underline;
    }
  }

  .produtos {
    display: flex;
    flex-wrap: wrap;
    p {
      margin-bottom: 0;
    }
  }

  @media (max-width: 600px) {
    .tag-status {
      display: none;
    }
  }

  @media (max-width: 800px) {
    .nota-fiscal {
      margin-bottom: 8px;
      flex-direction: column;
    }

    hr {
      display: none;
    }
  }
`

export const DetailsFooter = styled.div`
  display: flex;
  gap: 8px;

  @media (max-width: 800px) {
    .voltar {
      width: 100%;
    }
  }
`

export const Button = styled.button`
  ${({ theme }) => css`
    padding: 12px 16px;
    border-radius: 4px;

    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 16px;
    text-align: center;
    background: #27ae60;
    border: 2px solid #27ae60;
    color: #fff;

    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all ease-in-out 400ms;

    &:hover {
      background: #33a161;
    }

    img {
      margin-right: 12px;
    }

    &.outline-green {
      background: transparent;
      color: #27ae60;
      border: 2px solid #27ae60;
    }

    &.outline {
      background: transparent;
      color: #707070;
      border: 2px solid #707070;
    }

    @media (max-width: 800px) {
      width: 100%;

      &.outline {
        width: 100%;
      }
    }
  `}
`

export const ButtonPedidos = styled.button`
  ${({ theme }) => css`
    padding: 6px 8px;
    border-radius: 4px;

    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    font-size: 14px;
    text-align: center;
    background: #fff;
    border: 2px solid #27ae60;
    color: #27ae60;

    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all ease-in-out 400ms;

    &:hover {
      background: #33a161;
      color: #fff;
    }

    img {
      margin-right: 12px;
      color: #27ae60;
    }

    @media (max-width: 800px) {
      width: 100%;

      &.outline {
        width: 100%;
      }
    }
  `}
`

export const ButtonNFSemaforo = styled.a`
  ${({ theme }) => css`
    border: none;
  `}
`
export const ButtonAvaliacao = styled.button`
  background-color: white;
  color: #27ae60; /* verde */
  border: none;
  padding: 0;
  margin-top: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`
